import React from "react";
import { Checkbox } from "components/atoms/Checkbox";
import { CheckboxType } from "components/atoms/Checkbox/types";
import ControlsContainer from "components/molecules/ControlsContainer";
import { ImageDTO } from "types";
import * as Styled from "./GalleryImage.styled";
interface GalleryImageProps {
  item: ImageDTO;
  toggles: Record<string, boolean>;
  showEdit: boolean;
  showEditModal: boolean;
  isUserImage: (id: string) => boolean;
  handleToggle: (id: string) => void;
  handleEditClick: (id?: string) => void;
  prepareForDelete: (id: string) => void;
  handleVote: (id: string) => void;
  onImageClick: (image: any) => void;
  isSelectionMode: boolean;
  handleSelectImage: (imageId: string) => void;
  isSelected: boolean;
  userGallery: boolean;
  handleShareClick: (e: React.MouseEvent, imageId?: string) => void;
  showIcons?: boolean;
  handleCompetitionsClick: () => void;
  showDeleteConfirmation: boolean;
}
const GalleryImage: React.FC<GalleryImageProps> = ({
  item,
  toggles,
  showEdit,
  isUserImage,
  handleToggle,
  handleEditClick,
  prepareForDelete,
  handleVote,
  onImageClick,
  isSelectionMode,
  handleSelectImage,
  isSelected,
  userGallery,
  handleShareClick,
  showIcons = true,
  handleCompetitionsClick
}) => {
  return <Styled.ImageWrapper key={item.id} data-sentry-element="unknown" data-sentry-component="GalleryImage" data-sentry-source-file="index.tsx">
            <Styled.LazyLoadImage src={item.image} alt={"Generated artwork"} loading="lazy" onClick={() => isSelectionMode && userGallery ? handleSelectImage(item.id) : onImageClick(item)} $isSelected={isSelected} data-sentry-element="unknown" data-sentry-source-file="index.tsx" />
            {userGallery && <Checkbox type="checkbox" checked={isSelected} onChange={() => handleSelectImage(item.id)} className={isSelectionMode || isSelected ? "visible" : ""} id={`checkbox-${item.id}`} variant={CheckboxType.ERROR} />}
            {showIcons && <ControlsContainer imageInfo={item} toggles={toggles} handleToggle={handleToggle} handleShareClick={handleShareClick} handleCompetitionsClick={handleCompetitionsClick} handleEditClick={handleEditClick} prepareForDelete={prepareForDelete} handleVote={handleVote} showEdit={showEdit} isUserImage={isUserImage} />}
        </Styled.ImageWrapper>;
};
export default GalleryImage;